import * as React from 'react';
import { TImprovedContentMarketing } from '../../../../shared/types/contentMarketing';
import { getExperimentVariantFromConfig } from '../../../config';
import { Clickable } from '@fabric-ds/react';
import { UNLEASH_FEATURE_NAMES } from '../../../../shared/unleash/feature-names';
import { useMemo } from 'react';

type ContentMarketingTextContainerType = {
    smallText?: boolean;
    disableTextBalancer?: boolean;
    hideSponsor?: boolean;
    contentMarketing: TImprovedContentMarketing;
};

const TextContainer = ({
    contentMarketing,
    hideSponsor = false,
}: // smallText = false,
ContentMarketingTextContainerType) => {
    // const { deviceType } = getConfig();
    // const isMobile = deviceType === 'mobile';
    const title = contentMarketing.title.replace(/\\n/g, '<br/>');
    const cleanTitle = contentMarketing?.title.replace(/\\n/g, '');

    // const ref = useRef<HTMLParagraphElement>();
    // useTextBalancer(ref, disableTextBalancer || isMobile);

    const fontSizeExperiment = getExperimentVariantFromConfig(
        UNLEASH_FEATURE_NAMES.largeFontSizeContentMarketingExperiment,
    ) as
        | 'control' // 16reg22reg
        | 'challenger16reg22med';

    const { smallTextStyle, bigTextStyle } = useMemo(() => {
        switch (fontSizeExperiment) {
            case 'challenger16reg22med':
                return {
                    smallTextStyle: {
                        fontSize: 16,
                        fontWeight: 'normal',
                        lineHeight: '20px',
                    },
                    bigTextStyle: {
                        fontSize: 22,
                        fontWeight: 'bold',
                        lineHeight: '28px',
                    },
                };
            default:
                return {
                    smallTextStyle: {
                        fontSize: 16,
                        fontWeight: 'normal',
                        lineHeight: '20px',
                    },
                    bigTextStyle: {
                        fontSize: 22,
                        fontWeight: 'normal',
                        lineHeight: '28px',
                    },
                };
        }
    }, [fontSizeExperiment]);

    const accessibilityId = `cm-title-${contentMarketing.id}`;
    return (
        <div>
            {!hideSponsor && Boolean(contentMarketing.sponsorData.name) && (
                <div className={`text-gray-500 text-14 mb-4`}>
                    <span>{contentMarketing.sponsorData.name}</span>
                </div>
            )}
            {!!contentMarketing.text && (
                <div className={`mb-0 text-left`} style={smallTextStyle}>
                    {contentMarketing.text}
                </div>
            )}
            <h2
                className={`font-normal text-left mb-0 whitespace-pre-wrap text-ellipsis no-underline`}
                id={accessibilityId}
            >
                <Clickable
                    href={contentMarketing.href}
                    rel="noreferrer"
                    target="_blank"
                    title={cleanTitle}
                    id={accessibilityId}
                    className={
                        'link link--dark sf-ad-link text-gray-700 hover:no-underline focus:no-underline focus-ring'
                    }
                >
                    <div
                        className={`w-full text-left`}
                        style={bigTextStyle}
                        data-testid={'cm-title'}
                    >
                        {/*<div*/}
                        {/*    className={'balance-text'}*/}
                        {/*    data-testid={'cm-title'}*/}
                        {/*    ref={ref}*/}
                        {/*>*/}
                        {title}
                        {/*</div>*/}
                    </div>
                </Clickable>
            </h2>
        </div>
    );
};

export default TextContainer;
